import React from 'react'
import { SideInfo } from 'src/Pages/Auth/Side-info'
import { Wrapper } from './style'
import { RegisterForm } from './Form'
import SEO from 'src/seo'
const RegisterPage = () => {
  return (
    <Wrapper>
      <SEO title="Register" />
      <SideInfo children="Create an account" />
      <RegisterForm />
    </Wrapper>
  )
}

export { RegisterPage }
